function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from "react";
import { Root as CheckboxPrimitiveRoot, Indicator as CheckboxPrimitiveIndicator } from "@radix-ui/react-checkbox";
import { CheckIcon } from "@heroicons/react/20/solid";
import cc from "classcat";
import PropTypes from "prop-types";
import { twMerge } from "tailwind-merge";
import Label from "./Label";
Checkbox.propTypes = {
    className: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onFormSubmit: PropTypes.func,
    disabled: PropTypes.bool,
    name: PropTypes.string.isRequired,
    value: PropTypes.bool,
    id: PropTypes.string,
    label: PropTypes.node,
    LabelClassName: PropTypes.string
};
export default function Checkbox(_param) {
    var className = _param.className, onChange = _param.onChange, onFormSubmit = _param.onFormSubmit, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, name = _param.name, _param_value = _param.value, value = _param_value === void 0 ? false : _param_value, _param_id = _param.id, id = _param_id === void 0 ? null : _param_id, label = _param.label, LabelClassName = _param.LabelClassName, props = _object_without_properties(_param, [
        "className",
        "onChange",
        "onFormSubmit",
        "disabled",
        "name",
        "value",
        "id",
        "label",
        "LabelClassName"
    ]);
    if (!id) {
        id = name;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CheckboxPrimitiveRoot, _object_spread({
        onCheckedChange: function(checked) {
            return onChange({
                target: {
                    type: "checkbox",
                    name: name,
                    id: id,
                    checked: checked,
                    value: checked
                }
            });
        },
        onKeyDown: function(e) {
            if (e.key === "Enter") {
                onFormSubmit && onFormSubmit();
            }
        },
        disabled: disabled,
        name: name,
        id: id || name,
        checked: value,
        className: twMerge(cc([
            "dark:outline:border-blue-500 flex h-5 w-5 shrink-0 items-center justify-center rounded border border-gray-300 bg-gray-50 outline-none focus:border-blue-500 focus:ring-blue-500 dark:border-blue-750 dark:border-gray-600 dark:bg-blue-775 dark:focus:border-blue-500 dark:focus:border-blue-500 dark:focus:ring-blue-500 dark:focus:ring-blue-500 dark:focus-visible:border-blue-500 dark:focus-visible:ring-blue-500",
            {
                "cursor-not-allowed opacity-80": disabled
            },
            className,
            {
                "bg-blue-500 text-gray-50 dark:border-blue-500 dark:bg-blue-500": value
            }
        ]))
    }, props), /*#__PURE__*/ React.createElement(CheckboxPrimitiveIndicator, null, /*#__PURE__*/ React.createElement(CheckIcon, {
        className: "h-3 w-3"
    }))), label && /*#__PURE__*/ React.createElement(Label, {
        className: cc([
            "block text-sm dark:text-gray-200",
            LabelClassName
        ]),
        htmlFor: name
    }, label));
}
